import { createStyles, makeStyles, Theme } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { colors } from '../config/color';

interface IBG {
  marginBottom?: number;
  image: string;
}

export default function BG(props: IBG) {
  const [resolutiion, setResolutiion] = useState<string>('1');
  useEffect(() => getResolution(), []);

  const classes = makeStyles((theme: Theme) =>
    createStyles({
      bg: {
        zIndex: -1,
        bottom: props.marginBottom || 0,
        backgroundImage: `linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 8.5%), url('${props.image}')`,
        ['@media (max-width:576px)']: {
          zIndex: 3,
          bottom: 0,
          backgroundColor: colors.primary,
          backgroundImage: 'none',
          height: '60px !important',
          position: 'fixed !important',
        },
      },
    }),
  )();
  const getResolution = () => {
    const img = new Image();
    img.src = props.image;
    img.onload = function () {
      const res = img.height / img.width;
      setResolutiion(res.toString());
    };
  };

  return (
    <div
      className={classes.bg}
      style={{
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        position: 'absolute',
        width: '100%',
        height: `calc(100vw * ${resolutiion})`,
        left: 0,
      }}
    />
  );
}
